<template>
  <div :class="containerClass">
    <AccountGroupListItem
      v-for="id in itemIds"
      v-show="getFilteredAccountGroupIds.includes(id)"
      :key="id"
      :is-collapsed="groupCollapse[id]"
      :item-id="id"
      :item="groups[id]"
      :is-externally-mapped="getExternallyMappedGroupIds.includes(id)"
      :mapped-accounts="getFilteredGroupMappedAccounts[id]"
      :search-highlight="getSearchResultsByGroupId[id]"
      :total-mapped-count="getMappedAccountsNumbersPerGroup[id]"
      @item-clicked="itemClicked"
    />
    <div
      v-if="itemIds.length === 0"
      class="sf-pad-4 sf-align-c sf-c-text-darker"
    >
      {{ I18n.t('account_mapping_list.no_search_matches_exist') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import AccountGroupListItem from './account-group-list-item'
import { useCommon } from '@app/application/account-mapping/store/common'
import { useGroupList } from '@app/application/account-mapping/store/group-list'
import { useSearch } from '@app/application/account-mapping/store/search'

export default {
  components: {
    AccountGroupListItem,
  },
  emits: ['item-clicked'],
  computed: {
    ...mapState(useCommon, [
      'groups',
      'groupCollapse',
      'getExternalNumbersByAccountRange',
    ]),
    ...mapState(useGroupList, [
      'getFilteredAccountGroupIds',
      'getFilteredGroupMappedAccounts',
      'getMappedAccountsNumbersPerGroup',
      'getExternallyMappedGroupIds',
    ]),
    ...mapState(useSearch, [
      'getSearchResultsByGroupId',
      'getRemapDropdownGroupList',
    ]),
    itemIds: function () {
      return this.getRemapDropdownGroupList
    },
    containerClass: function () {
      return 'account-group-list__container'
    },
  },
  methods: {
    itemClicked(payload) {
      this.$emit('item-clicked', payload)
    },
  },
}
</script>
<style lang="scss" scoped>
.account-group-list {
  &__container {
    overflow-y: auto;
    max-height: 500px;
  }
}
</style>
